/*  Dashboard ▸ Overview  */
import React from 'react';
import {connect} from 'react-redux';

import WidgetWorkspace from './widgets/WidgetWorkspace';
import DateRangeSelector from './DateRangeSelector';
import RightAsidePanel from './RightAsidePanel';

import {reduxToggleSidePanel} from 'appredux/actions';
import {ESidePanelView} from 'constants/index';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faGrid2} from '@fortawesome/pro-regular-svg-icons';
import InviteCodePanel from 'screens/Dashboard/Customers/InviteCodePanel/InviteCodePanel';

import './Overview.scss';

/* ------------------------------------------------------------------ */
type Props = {user: {name: string; isAdmin: boolean}};

function Overview({user}: Props) {
  const openCustomisePanel = () =>
    reduxToggleSidePanel(true, {panelType: ESidePanelView.CUSTOMISE_OVERVIEW});

  return (
    <div className="overview-container">
      <InviteCodePanel />
      {/* ───── greeting strip ───── */}
      <header className="overview-header">
        <p className="greeting">{greet(user.name)}</p>
      </header>

      {/* ───── headline row (title + date + customise) ───── */}
      <h1 className="overview-heading">
        <span className="title">
          Here’s what’s happening&nbsp;
          <DateRangeSelector />
        </span>

        <button className="btn customise-btn" onClick={openCustomisePanel}>
          Customise&nbsp;
          <FontAwesomeIcon icon={faGrid2} className="customise-icon" />
        </button>
      </h1>

      {/* ───── main grid ───── */}
      <section className="overview-grid">
        <div className="grid-canvas">
          <WidgetWorkspace />
        </div>

        <aside className="grid-aside">
          <RightAsidePanel />
        </aside>
      </section>
    </div>
  );
}

/* ───────── helpers ───────── */
const greet = (n: string) => {
  const hr = new Date().getHours();
  const period = hr < 12 ? 'morning' : hr < 18 ? 'afternoon' : 'evening';
  return `Good ${period}, ${n}`;
};

export default connect((s: any) => ({user: s.user}))(Overview);
